import { render, staticRenderFns } from "./HelpAnswerModal.vue?vue&type=template&id=ccc9b624&scoped=true"
import script from "./HelpAnswerModal.vue?vue&type=script&lang=js"
export * from "./HelpAnswerModal.vue?vue&type=script&lang=js"
import style0 from "./HelpAnswerModal.vue?vue&type=style&index=0&id=ccc9b624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc9b624",
  null
  
)

export default component.exports